import {
	IWorkOrder,
	IWorkOrderEditPayload,
} from '@app/domain/cmms-types/workorder-types';
import { LocationInput } from '../interfaces/cmms-global.interfaces';

export function workOrderIntoCreateWorkOrder(
	workOrder: IWorkOrder
): IWorkOrderEditPayload {
	return {
		name: workOrder.name,
		priority: workOrder.priority,
		description: workOrder.description,
		locations: workOrder.locations.map(
			location =>
				({
					locationId: location.id,
					name: location.name,
					locationType: location.contentType.toLowerCase(),
				}) as LocationInput
		),
		category: workOrder.category,
		timeframe: workOrder.timeframe,
		costOfWork: workOrder.costOfWork,
		deviationType: workOrder.deviationType,
		costAllocation: workOrder.costAllocation,
		deadline: workOrder.deadline as unknown as string,
		assignee: workOrder.assignee?.psId,
		assigneeType: workOrder.assignee?.contentType,
		approver: workOrder.approver?.psId,
		approverType: workOrder.approver?.contentType,
		routineData: workOrder.routineData,
		labels: workOrder.labels?.map(label => label.pk),
		assets: [],
	};
}
